import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/ui');

export enum LoadersNames {
  fetchingData = 'fetchingData',
  fetchingUser = 'fetchingUser',
  loggingIn = 'loggingIn',
}

export const showLoader = actionCreator<LoadersNames>('SHOW_LOADER');
export const hideLoader = actionCreator<string>('HIDE_LOADER');

export const requireLogin = actionCreator<void>('REQUIRE_LOGIN');
